const LayersArray = [
    'DEFAULT/FALLBACK',
    'CURR_VALUE_1',
    'CURR_VALUE_2',
    'CURR_VALUE_3',
    'CURR_VALUE_4',
    'CURR_VALUE_5',
    'CURR_VALUE_9',
    'CURR_VALUE_10',
    'CURR_VALUE_100',
    'CURR_VALUE_998',
    'CURR_VALUE_999',
    'CURR_VALUE_1000',
    'CURR_VALUE_9999',
    'CURR_VALUE_100000000',
];

const layerNameMirrorReducer = (accumulator, name) => {
    accumulator[name] = name;
    return accumulator;
};

export const LayerNames = {
    ...LayersArray.reduce(layerNameMirrorReducer, {}),
};

const layerNameReducer = (accumulator, name, index) => {
    accumulator[name] = index;
    return accumulator;
};

const Layers = {
    ...LayersArray.reduce(layerNameReducer, {}),
};

export const getZIndexByLayerName = name => (
    LayersArray.includes(name)
        ? Layers[name]
        : Layers[LayersArray[0]]
);
